import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import styles from "assets/jss/material-dashboard-react/components/typographyStyle.js";

const useStyles = makeStyles(styles);

export default function Danger(props) {
  const classes = useStyles();
  const { children, defaultFontStyle, dangerText, hbFontStyle } = props;
  const dangerClasses = classNames({
    [classes.defaultFontStyle]: defaultFontStyle,
    [classes.hbFontStyle]: hbFontStyle,
    [classes.dangerText]: dangerText,
  });
  return (
    <div className={classes.dangerText + " " + dangerClasses}>
      {children}
    </div>
  );
}

Danger.propTypes = {
  children: PropTypes.node
};
